import { tablePadding } from "@core/table";
import { tokens } from "@core/theme/tokens";

// Medidas tomadas de SegBitacora del prototipo; los tokens cubren color,
// tipografía, radios y superficies, no las proporciones de esta tabla.
// La barra de filtros, el input de filtro y el diálogo de "Filtros
// adicionales" son idénticos a los de `httpRequestLogStyles.ts` — viven en
// `@portal/common/securityLogStyles` (jscpd, revisión de duplicación
// 2026-09-23).
export const accessLogStyles = {
  failureBadge: {
    display: "inline-flex",
    alignItems: "center",
    width: "fit-content",
    whiteSpace: "nowrap",
    padding: "6px 11px",
    borderRadius: 999,
    border: "1px solid rgba(214,124,104,0.34)",
    background: "rgba(214,124,104,0.13)",
    color: tokens.danger.base,
    font: `600 10.5px/1 ${tokens.font.ui}`,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
  },
  successBadge: {
    display: "inline-flex",
    alignItems: "center",
    width: "100%",
    whiteSpace: "nowrap",
    gap: 5,
    padding: "6px 11px",
    borderRadius: 999,
    border: "1px solid rgba(232,234,238,0.28)",
    background: "rgba(232,234,238,0.12)",
    color: "#DDDFE3",
    font: `600 11px/1 ${tokens.font.ui}`,
    letterSpacing: "0.03em",
  },
  accountText: {
    color: tokens.text.secondary,
    font: `500 12px ${tokens.font.ui}`,
  },
  table: {
    // Ancho FIJO de la columna "Resultado": los 150px del prototipo
    // (admin.jsx:3720, `1.5fr 130px 190px 1fr 150px`). Fijo y no `auto`: cada
    // fila de `CursorTable` es su propia grilla y un `minmax(piso, auto)` se
    // resuelve fila por fila, corriendo Cuenta, Fecha y Origen respecto del
    // encabezado (la prueba visual verifica que todas las filas resuelven las
    // mismas pistas). Una versión previa (2026-09-30) subió a 248px para que
    // el badge más largo no se cortara; eso desplazaba 59px las columnas
    // Cuenta, Fecha y Origen contra el canónico (0.0346 contra el umbral
    // 0.005) y se revirtió por resolución humana W-SCOPE-01 (2026-10-06):
    // el prototipo es el oráculo. El texto completo del motivo sigue en el
    // `Tooltip` de la celda.
    resultWidth: "150px",
    minWidth: 940,
    headerPadding: tablePadding("18px", "11px"),
    rowPadding: tablePadding("12px"),
  },
} as const;
